import { render, staticRenderFns } from "./ShowClientSalePerson.vue?vue&type=template&id=771d4810"
import script from "./ShowClientSalePerson.vue?vue&type=script&lang=js"
export * from "./ShowClientSalePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports